// ChakraUI prebuilt components
import { Text } from "@chakra-ui/react";
import TextTheme from "./theme";
export { Text, TextTheme };
//# sourceMappingURL=index.js.map